export const UPDATE_SERVER_ON_DATES = 'UPDATE_SERVER_ON_DATES';
export const UPDATE_SERVER_ON_DATES_SUCCESS = 'UPDATE_SERVER_ON_DATES_SUCCESS';
export const UPDATE_SERVER_ON_DATES_FAILURE = 'UPDATE_SERVER_ON_DATES_FAILURE';

export const updateServerOnDates = (data) => {
    return {
        type: UPDATE_SERVER_ON_DATES,
        data
    }
}

export const updateServerOnDatesSuccess = (data) => {
    return {
        type: UPDATE_SERVER_ON_DATES_SUCCESS,
        data
    }
}
export const updateServerOnDatesFailure = (data) => {
    return {
        type: UPDATE_SERVER_ON_DATES_FAILURE,
        data
    }
}